
export const ADD_PROFILE_DETAILS = 'ADD_PROFILE_DETAILS'
export const ADD_PROFILE_IMAGE = 'ADD_PROFILE_IMAGE'
export const ADD_APPLICATION_LOGO = 'ADD_APPLICATION_LOGO'
export const SET_CURRENT_PRODUCT_UUID = 'SET_CURRENT_PRODUCT_UUID'
export const FCM_TOKEN = 'FCM_TOKEN'

export const profileImages = (payload: any) => (console.log("payload"), {
  type: ADD_PROFILE_IMAGE,
  payload: payload,
});
export const Logo = (payload: any) => (console.log(payload, "payload"), {
  type: ADD_APPLICATION_LOGO,
  payload: payload,
});
export const profileSettings = (payload: any) => ({
  type: ADD_PROFILE_DETAILS,
  payload: payload,
});
export const currentProductUuid = (payload: any) => ({
  type: SET_CURRENT_PRODUCT_UUID,
  payload: payload,
});
export const fcmToken = (payload: any) => ({
  type: FCM_TOKEN,
  payload: payload
});